// base
import { createAction } from '@reduxjs/toolkit';

// default
export const UI = 'ui';
export const UI_SLICE_NAME = `${UI}Slice`;

// action
const UI_PAGE_LOADER = `${UI}/pageLoader`;

// createAction
const pageLoaderAction = createAction(UI_PAGE_LOADER);

// actions
export const actions = {
  pageLoaderAction,
};
